import React, { memo } from "react";
import classNames from "classnames/bind";
import styles from "../AuthModal.module.scss";
import { UserRound } from "lucide-react";

const cx = classNames.bind(styles);

const ModalHeader = memo(({ title, onClose }) => {
  return (
    <div className={cx("modal__header")}>
      <div className={cx("header-title")}>
        <p>
          <UserRound size={28} strokeWidth={2.5} />
        </p>
        <h4>{title}</h4>
      </div>
      <button className={cx("close__button")} onClick={onClose}>
        ×
      </button>
    </div>
  );
});

ModalHeader.displayName = "ModalHeader";

export default ModalHeader;
